import { type PropsValue } from 'react-select';

import { type OptionType } from '@hivebrite/design-system/Inputs';

type ValueType =
  | Array<number>
  | Array<object>
  | PropsValue<OptionType>
  | number
  | object
  | null;

/**
 * Extracts numeric IDs from various value formats
 */
export const extractIds = (value: ValueType): Array<number> => {
  if (typeof value === 'number') {
    return [value];
  }

  if (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every((v) => typeof v === 'number')
  ) {
    return value as Array<number>;
  }

  return [];
};
